import React, { SyntheticEvent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import Modal from './Modal/Modal';
import ButtonCancel from './Form/ButtonCancel';

interface Props {
    className?: string;
    value?: any;
    modalBody?: JSX.Element;
    onClick: (value: any) => void;
}

interface State {
    modalVisible: boolean;
}

type PropType = Props & InjectedIntlProps;

class DeleteButton extends React.Component<PropType, State> {
    public state = {
        modalVisible: false,
    };

    private onClick = (e: SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({modalVisible: true});
    }

    private onModalClose = (e: SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({modalVisible: false});
    }

    private onModalSubmit = (e: SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClick(this.props.value);
        this.setState({modalVisible: false});
    }

    private renderModalBody = () => {
        return this.props.modalBody || <p>{this.props.intl.formatMessage({id: 'component.DeleteButton.modalBody'})}</p>;
    }

    private renderModalButtons = () => {
        return (
            <div className="row">
                <div className="col-sm-6">
                    <div className="pull-left">
                        <ButtonCancel onClick={this.onModalClose} />
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="pull-right">
                        <button type="submit" className="btn btn-danger" onClick={this.onModalSubmit}>
                            {this.props.intl.formatMessage({id: 'common.delete'})}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    public render() {
        const className = `btn btn-danger ${this.props.className}`;
        return (
            <>
                <button
                    className={className}
                    onClick={this.onClick}>
                    {this.props.children || this.props.intl.formatMessage({id: 'common.delete'})}
                </button>
                {this.state.modalVisible && (
                    <Modal
                        visible={this.state.modalVisible}
                        onClose={this.onModalClose}
                        title={this.props.intl.formatMessage({id: 'component.DeleteButton.modalTitle'})}
                        renderBody={this.renderModalBody}
                        renderButtons={this.renderModalButtons}
                    />
                )}
            </>
        );
    }
}

export default injectIntl(DeleteButton);


// WEBPACK FOOTER //
// ./src/components/DeleteButton.tsx